import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

    *,*::before,*:after{
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        font-family: Raleway, sans-serif;
    }
    .special-label{
        display: none;
    }
    body{
        font-family: 'Raleway', sans-serif;
        font-variant-numeric: lining-nums;
        background-color: ${({theme}) => theme.mainBgColor};

        //! bak burası sıkıntı biraz
        overflow-x: hidden;
    }

    input,button, textarea{
        border: none;
        outline: none;
        color: inherit;
        font-weight: inherit;
        font-size: inherit;
        font-variant-numeric: lining-nums;
        background-color: transparent;

    }

    button{
        cursor: pointer;
    }

    li{
        list-style: none;
    }
    a{
        text-decoration: none;
        color: initial;
    }

    .toast-container{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
    }

    :root{
        --color-red: #FF0000;
        --color-dark-red: #EBB00E;
        --color-dark: #3C3C3B;
        --color-green: #5CB34F;
        --color-green-lighter: #9ded9a;
        --color-yellow: #EBB00E;
        --color-light:#F4F4F4;
        --color-white:#fff;
        --color-disabled:#BEBEBE;

        
        --color-main: #E85446;

        --font-weight-sm: 400;
        --font-weight-md: 500;
        --font-weight-lg: 600;
        --font-weight-xl: 700;

        --font-size-xs: 12px;
        --font-size-sm: 14px;
        --font-size-md: 16px;
        --font-size-lg: 18px;
        --font-size-xl: 20px;

        --breakXL:87.5em;
        --breakL:75em;
        --breakM:61.9375em;
        --breakS:47.9375em;
        --breakSM:36em;

    }
`;

export default GlobalStyles;
